module.exports = __webpack_public_path__ + "img/thumbnail.92068bbd.png";